const motorPreguntas = ({
	preguntas,
	modo = "libre"
}) => {

	if (!preguntas?.length) {
		return null;
	}

	switch (modo) {

		case "libre":

			return preguntas[
				Math.floor(
					Math.random() *
					preguntas.length
				)
			];

			case "simulacro":

			return preguntas[
				Math.floor(
					Math.random() * preguntas.length
				)
			];

		default:

			return preguntas[
				Math.floor(
					Math.random() *
					preguntas.length
				)
			];
	}
};

export default motorPreguntas;